module.exports = __webpack_public_path__ + "img/delivery-justeat.e9d13d0d.svg";